export default __webpack_public_path__ + "7b5cae042fc59f1e05711589e2ef2df4.png";